<template>
  <page-outline :title="pageTitle">
    <template slot="pageContent">
      <b-row class="pb-5 no-gutter">
        <back-button :returnUrl="returnUrl"></back-button>
      </b-row>
      <spinner v-if="activateSpinner"></spinner>
      <kafka-configuration-form v-else v-model="config" :readonly="!editMode" :mode="mode"></kafka-configuration-form>
      <b-row class="justify-content-end mt-3 no-gutters">
        <b-button v-if="mode === 'create'"
        @click="createConfig" variant="primary">
          <i class="fa-light fa-save"></i>
          <span>{{$t('common.sve')}}</span>
        </b-button>
        <b-button class="mr-3" v-if="mode === 'details' && editMode === false && canEditConfig"
        @click="editModeActivate" variant="primary">
          <span>{{$t('common.routing.edit_this_config')}}</span>
        </b-button>
        <b-button class="mr-3" v-if="mode === 'details' && editMode === false && canDeleteConfig"
        @click="deleteConfig" variant="primary">
          <i class="fa-light fa-trash"></i>
          <span>{{$t('common.routing.delete_config')}}</span>
        </b-button>
        <b-button variant="primary" v-if="mode === 'details' && editMode === true"
          @click="editConfig">
          <i class="fa-light fa-save"></i>
          <span>{{ $t('common.sve') }}</span>
        </b-button>
      </b-row>
    </template>
  </page-outline>
</template>

<script>

import FormAccordion from '@/components/common/FormAccordion.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'
import {errorMessageAlert} from '@/helpers/alert'
import backButton from "@/components/common/backButton.vue"
import Spinner from '@/components/common/spinner.vue'
import kafkaConfigurationForm from '@/pages/routing/KafkaConfigurationForm.vue'

import {loadPage} from '@/helpers/routing'


export default {
  name: 'MessageDetails',
  components: {
    'back-button': backButton,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'page-outline': PageOutline,
    'spinner': Spinner,
    'kafka-configuration-form': kafkaConfigurationForm
  },
  props: {
    mode: {
      type: String,
      default: "create"
    }
  },
  computed: {
    canDeleteConfig () {
      return this.$engine.rights.rightIs('kafkaConfig_supprimer', true)
    },
    canEditConfig () {
      return this.$engine.rights.rightIs('kafkaConfig_editer', true)
    },
    pageTitle () {
      return this.mode === "details" ? this.$t('Webheader.kafka_details') : this.$t('Webheader.kafka_add')
    },
  },
  data () {
    return {
      activateSpinner: false,
      config: {},
      editMode: false,
      returnUrl: '/routing/configurationList/KAFKA',
      savedConfig: []
    }
  },
  created () {
    this.activateSpinner = true
    if (this.mode === "details") {
      let that = this
      this.activateSpinner = true
      this.$engine.routing.config.kafka.fetch({idConfigKafka: this.$engine.routing.config.clickedConfig.idConfigKafka})
      .then(resp => {
        if (resp.data && resp.data.configKafka && resp.data.configKafka.length) {
          that.savedConfig = resp.data.configKafka[0]
          that.config = resp.data.configKafka[0]
          that.config = {
            brokers : that.config.brokers,
            topic : that.config.topic,
            name : that.config.name,
            login : that.config.Login,
            password : that.config.Password
          }
        }
        this.activateSpinner = false
      })
      .catch(err => {
        errorMessageAlert(err, that)
      })
      this.fillFields()
      this.$engine.routing.config.clickedConfig = {}
    } else {
      this.editMode = true
    }

    this.$f7.initPullToRefresh()
    this.activateSpinner = false
  },
  mounted () {
  },
  beforeDestroy () {
  },
  methods: {
    editConfig () {
      let that = this

      if (this.formHasError()) {
        return
      }

      let params = {
        idConfigKafka: this.savedConfig.idConfigKafka,
        name: this.config.name,
        brokers: this.config.brokers,
        topic: this.config.topic
      }
      this.$engine.routing.config.kafka.edit(params)
      .then(resp => {
        that.$f7.modal({
          title: this.$t('common.routing.config_edited'),
          buttons: [
            {
              text: 'OK',
              onClick: function () {
                return
              }
            }
          ]
        })
        loadPage(that, {url: '/routing/configurationList/KAFKA'})
      })
      .catch(e => {
        errorMessageAlert(e, that)
        this.okMessageBox(this.$t('common.routing.config_edition_error'))
      })
    },
    editModeActivate () {
      this.editMode = true
    },
    fillFields () {
      this.config.name = this.savedConfig.Name
      this.config.brokers = this.savedConfig.brokers
      this.config.topic = this.savedConfig.topic
      this.config.sslActive = this.savedConfig.SSLMode
      this.config.login = this.savedConfig.Login
      this.config.password = this.savedConfig.Password
    },
    formHasError () {
      if (this.config.name === undefined || this.config.name.length === 0) {
        this.okMessageBox(this.$t('common.routing.config_name_missing'))
        return true
      }
      if (this.config.brokers === undefined || this.config.brokers.length === 0) {
        this.okMessageBox(this.$t('common.routing.brokers_missing'))
        return true
      }
      if (this.config.topic === undefined || this.config.topic.length === 0) {
        this.okMessageBox(this.$t('common.routing.topic_missing'))
        return true
      }
      return false
    },
    goBack () {
      if (this.editMode === true) {
        this.editMode = false
        this.fillFields()
      }
      else {
        loadPage(this, {url: '/routing/configurationList/KAFKA'})
      }
    },
    okMessageBox (message) {
      this.$f7.modal({
        title: message,
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    }
  }
}
</script>
